import React from 'react';

export const StandingDataTitle: React.FC = () => <>Stammdaten</>;

export default StandingDataTitle;
